export const environment = {
  production: false,
  //endPoint: 'http://labs.lucasian.com/autoliquidacion.back-1.0/rest/',
  // endPoint: 'https://enlineades.ccc.org.co/autoliquidacion.back-1.0/rest/',
  // endPoint: 'http://enlineapruebas.ccc.org.co/autoliquidacion.back-1.0/rest/',
  endPoint: '/autoliquidacion.back-1.0/rest/',
  //endPoint: 'http://localhost:7001/autoliquidacion.back-1.0/rest/',
  descargaCertificadoUrl: 'https://sedevirtual.ccc.org.co/certificadoElectronico',
  codCamara: 8
};

